














import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { ApplicationInsightsEventEnum } from "@/lib/enum/application-insights-event.enum";
import { AttachmentResponseModule } from "@/store/modules/attachment-response.store";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { ConfirmActionDialog }
})
export default class AttachmentRequestContinueDialog extends Vue {
  async mounted() {
    this.$appInsights.trackEvent(
      { name: ApplicationInsightsEventEnum.OPEN_ATTACHMENT_REQUEST_CONTINUE_DIALOG },
      { partnerId: PartnerModule.partner.id }
    );
  }

  async abort() {
    AttachmentResponseModule.clearOngoingAttachmentRequest();
    await this.$router.push({
      name: "ReportHome"
    });
    this.$emit("close");
  }

  async next() {
    await this.$router.push({
      name: "ReportDataResponse",
      params: {
        accessToken: AttachmentResponseModule.attachmentRequestToken || ""
      }
    });
    this.$emit("close");
  }
}
